<section class="sec" id="benefits">
  <div class="wrap">
    <div class="sec-head" appReveal>
      <span class="kicker">Benefits</span>
      <h2>Redefine your customers' digital experience</h2>
    </div>
    <div class="benefits-wrap">
      <div class="benefits-visual" appReveal>
        <img src="assets/landing-page-v1/bg-1.webp" alt="ConnectNow benefits" onerror="this.style.display='none'">
        <div class="bv-card">
          <div class="stat">2× – 4×</div>
          <span>uplift in overall sales via 24×7 real-time virtual selling.</span>
        </div>
      </div>
      <ul class="ben-list">
        <li class="ben-item" appReveal>
          <span class="chk"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M3 17l5-5 4 3 8-9" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16 6h5v5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
          <div><h4>Increase Sales Conversions</h4><p>Increase customer connections and 2×–4× overall sales via 24×7 real-time virtual sales experiences.</p></div>
        </li>
        <li class="ben-item" appReveal>
          <span class="chk"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></span>
          <div><h4>Maximize Efficiency</h4><p>AI agents handle repetitive tasks so your team focuses on high-value interactions — faster, more cost-effective resolutions.</p></div>
        </li>
        <li class="ben-item" appReveal>
          <span class="chk"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M4 18V8m6 10V4m6 14v-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M20 8l1-3M20 8l3-1" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></span>
          <div><h4>Cost-Effective Scaling</h4><p>Grow operations without increasing headcount by leveraging AI to handle high call volumes.</p></div>
        </li>
        <li class="ben-item" appReveal>
          <span class="chk"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/><path d="M12 7v5l3 2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></span>
          <div><h4>24/7 Availability</h4><p>AI agents never rest, while human agents step in whenever specialized expertise is required.</p></div>
        </li>
        <li class="ben-item" appReveal>
          <span class="chk"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 3l2.5 5.5L20 9l-4 4 1 6-5-3-5 3 1-6-4-4 5.5-.5L12 3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></span>
          <div><h4>Increased Customer Satisfaction</h4><p>An intuitive, seamless and consistent experience for every one of your customers.</p></div>
        </li>
      </ul>
    </div>
  </div>
</section>
